import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { ReplaySubject} from "rxjs";
import {IddTrainingCertificate} from "../../../shared/interface/idd-training-certificate";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";

@Component({
  selector: 'app-idd-trainings-certificates-details-view',
  templateUrl: './idd-trainings-certificates-details-view.component.html',
  styleUrls: ['./idd-trainings-certificates-details-view.component.scss']
})
export class IddTrainingsCertificatesDetailsViewComponent implements OnInit, OnDestroy  {
  @Input() iddTrainingCertificateObject: IddTrainingCertificate;
  @Output() modifyClicked = new EventEmitter<any>();

  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  floor(num: number): number {
    return Math.floor(num);
  }

  modify(): void {
    this.modifyClicked.emit();
  }
}
